import styled from 'styled-components';

import { GridContainer, GridItem } from '@xing-com/grid';
import {
  mediaTopBarHidden,
  mediaTopBarVisible,
  mediaSmallOrTiny,
  mediaConfined,
} from '@xing-com/layout-tokens';
import * as tokens from '@xing-com/tokens';
import { Headline } from '@xing-com/typography';

export const ProductHeaderContainer = styled(GridContainer)`
  padding-top: ${tokens.scale070};

  @media ${mediaConfined} {
    padding-top: ${tokens.scale110};
  }

  @media ${mediaTopBarHidden} {
    padding-top: ${tokens.space5XL};
    row-gap: ${tokens.spaceXXL};
  }
`;

export const StyledHeadline = styled(Headline)`
  margin: 0;
`;

export const StyledGridContainer = styled(GridContainer)`
  @media ${mediaTopBarVisible} {
    row-gap: ${tokens.scale190};
  }

  @media ${mediaSmallOrTiny} {
    row-gap: ${tokens.scale160};
  }
`;

export const ProductCtasWrapper = styled(GridItem)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  row-gap: ${tokens.space3XL};
  order: 1;

  @media ${mediaTopBarHidden} {
    order: initial;
  }
`;

export const Picture = styled.picture`
  display: block;
  position: relative;
  width: 100%;

  &::after {
    content: ' ';
    display: block;
    width: 100%;
    height: 0;
    padding-top: calc((449 / 456) * 100%);
  }
`;
export const Image = styled.img`
  width: 100%;
  border-radius: ${tokens.spaceXL};
`;
